import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TrustContentPipe } from './trust-content.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [TrustContentPipe],
  exports: [TrustContentPipe]
})
export class TrustContentModule {}
